/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getTumors } from 'app/entities/tumor/tumor.reducer';
import { createEntity, getEntity, reset, updateEntity } from './tumor-measurement.reducer';

export const TumorMeasurementUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const tumors = useAppSelector(state => state.tumor.entities);
  const tumorMeasurementEntity = useAppSelector(state => state.tumorMeasurement.entity);
  const loading = useAppSelector(state => state.tumorMeasurement.loading);
  const updating = useAppSelector(state => state.tumorMeasurement.updating);
  const updateSuccess = useAppSelector(state => state.tumorMeasurement.updateSuccess);

  const handleClose = () => {
    navigate(`/tumor-measurement${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaries({}));
    dispatch(getTumors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.incidentDate !== undefined && typeof values.incidentDate !== 'number') {
      values.incidentDate = Number(values.incidentDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tumorMeasurementEntity,
      ...values,
      measurementName: clinicalDictionaries.find(it => it.id.toString() === values.measurementName?.toString()),
      tumor: tumors.find(it => it.id.toString() === values.tumor?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...tumorMeasurementEntity,
          measurementName: tumorMeasurementEntity?.measurementName?.id,
          tumor: tumorMeasurementEntity?.tumor?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tumorMeasurement.home.createOrEditLabel" data-cy="TumorMeasurementCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tumorMeasurement.home.createOrEditLabel">Create or edit a TumorMeasurement</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tumor-measurement-id"
                  label={translate('tinyMedicRestApp.tumorMeasurement.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorMeasurement.incidentDate')}
                id="tumor-measurement-incidentDate"
                name="incidentDate"
                data-cy="incidentDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorMeasurement.measurementValue')}
                id="tumor-measurement-measurementValue"
                name="measurementValue"
                data-cy="measurementValue"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorMeasurement.measurementUnit')}
                id="tumor-measurement-measurementUnit"
                name="measurementUnit"
                data-cy="measurementUnit"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorMeasurement.active')}
                id="tumor-measurement-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorMeasurement.cursor')}
                id="tumor-measurement-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorMeasurement.lastUpdated')}
                id="tumor-measurement-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorMeasurement.microSec')}
                id="tumor-measurement-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorMeasurement.timestampEntry')}
                id="tumor-measurement-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="tumor-measurement-measurementName"
                name="measurementName"
                data-cy="measurementName"
                label={translate('tinyMedicRestApp.tumorMeasurement.measurementName')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-measurement-tumor"
                name="tumor"
                data-cy="tumor"
                label={translate('tinyMedicRestApp.tumorMeasurement.tumor')}
                type="select"
              >
                <option value="" key="0" />
                {tumors
                  ? tumors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tumor-measurement" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TumorMeasurementUpdate;
